import React from "react";

import logo from "../images/forms_live-icon.png";

export default function Navbar() {
  return (
    <nav className="relative flex flex-wrap items-center justify-between px-2 py-1 mb-0 border-y-2 ">
      <div className="container px-4 mx-auto flex flex-wrap items-center justify-between ">
        <div className="w-full relative flex justify-between lg:w-auto px-4 lg:static lg:block lg:justify-start">
          <a
            className="text-sm font-bold leading-relaxed inline-block mr-4 py-4 px-6 whitespace-nowrap uppercase text-white rounded-2xl"
            href="/"
          >
            <img src={logo} alt="Forms Live Logo" className="h-12 w-12" />
          </a>
        </div>
      </div>
    </nav>
  );
}
